if (!customElements.get('inpage-navigation')) {
  customElements.define('inpage-navigation', class InpageNavigation extends HTMLElement {
    constructor() {
      super();

      this.buyNowButton = this.querySelector('.js-buy-now');
      if (this.buyNowButton) {
        this.buyNowButton.addEventListener('click', this.scrollToBuyGrid.bind(this));
      }
    }

    scrollToBuyGrid(event) {
      const target = document.getElementById('buy-grid');
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', '#buy-grid');
    }
  });
}
